import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "./pages/home/Home";
import { preloadPlayedVideoPage } from "./pages/playedVideo/preloadPlayedVideoPage";

const LandingPage = lazy(() => import("./pages/landingPage/LandingPage"));
const PlayedVideo = lazy(() => preloadPlayedVideoPage());
const Contact = lazy(() => import("./pages/contact/Contact"));
const TermAndCondition = lazy(() =>
  import("./pages/termandcondition/TermAndCondition")
);
const PrivacyPolicy = lazy(() =>
  import("./pages/privacypolicy/PrivacyPolicy")
);
const MaintenanceModel = lazy(() =>
  import("./components/maintenance/MaintenanceModel")
);
const ToastHost = lazy(() => import("./components/default/ToastHost"));

const RouteFallback = () => <div className="min-h-screen bg-white" />;

const App = () => {
  const { t, i18n } = useTranslation();
  const [showToastHost, setShowToastHost] = useState(false);

  useEffect(() => {
    document.title = t("storiesForLife");
  }, [i18n.language, t]);

  useEffect(() => {
    if ("requestIdleCallback" in window) {
      const idleCallbackId = window.requestIdleCallback(() => {
        setShowToastHost(true);
      }, { timeout: 2000 });

      return () => {
        window.cancelIdleCallback(idleCallbackId);
      };
    }

    const timeoutId = window.setTimeout(() => {
      setShowToastHost(true);
    }, 1200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/" element={<Home />} />
          <Route path="/story/:id" element={<PlayedVideo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/termandcondtion" element={<TermAndCondition />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/maintenance" element={<MaintenanceModel />} />
        </Routes>
      </Suspense>

      {showToastHost && (
        <Suspense fallback={null}>
          <ToastHost />
        </Suspense>
      )}
    </BrowserRouter>
  );
};

export default App;
